(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updatePageProgress = (flkty, bar) => {
      if (!flkty || !bar) return;
      const totalPages = flkty.slides.length || 1;
      const currentPage = flkty.selectedIndex + 1;
      bar.style.width = `${(currentPage / totalPages) * 100}%`;
    };

    const bindShowcaseControls = (root) => {
      const wrap = root.querySelector('.collection-showcase__carousel-wrap');
      if (!wrap || wrap.dataset.controlsBound === 'true') return;

      const slideshow = wrap.querySelector('.collection-showcase__carousel');
      const prev = wrap.querySelector('.collection-showcase__nav--prev');
      const next = wrap.querySelector('.collection-showcase__nav--next');
      const progressBar = wrap.querySelector('.collection-showcase__progress-bar');
      if (!slideshow || !prev || !next) return;

      const attach = () => {
        const flkty = typeof Flickity !== 'undefined' ? Flickity.data(slideshow) : null;
        if (!flkty) {
          requestAnimationFrame(attach);
          return;
        }

        wrap.dataset.controlsBound = 'true';
        prev.addEventListener('click', () => flkty.previous());
        next.addEventListener('click', () => flkty.next());

        if (progressBar) {
          updatePageProgress(flkty, progressBar);
          flkty.on('change', () => updatePageProgress(flkty, progressBar));
        }
      };

      attach();
    };

    const init = (event) => {
      const scope = event && event.target ? event.target : document;
      scope.querySelectorAll('.section-collection-showcase').forEach(bindShowcaseControls);
    };

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatNumber(num) {
      return Number(num).toLocaleString('en-US');
    }

    function calculateDynamicTarget(baseNumber, baseDateStr) {
      var base = parseInt(baseNumber, 10);

      if (isNaN(base)) {
        base = 0;
      }

      if (!baseDateStr) {
        return base;
      }

      var baseDate = new Date(baseDateStr + 'T00:00:00-07:00').getTime();

      if (isNaN(baseDate)) {
        return base;
      }

      var now = Date.now();

      if (now <= baseDate) {
        return base;
      }

      var daysPassed = Math.floor((now - baseDate) / (1000 * 60 * 60 * 24));

      var additionalUsers = 0;

      for (var i = 0; i <= daysPassed; i++) {
        additionalUsers += ((i * 17) % 5) + 1;
      }

      return base + additionalUsers;
    }

    function animateValue(el, start, end, duration) {
      var startTimestamp = null;
      var lastUpdate = 0;
      var updateInterval = 50;

      function step(timestamp) {
        if (!startTimestamp) {
          startTimestamp = timestamp;
        }

        var progress = Math.min((timestamp - startTimestamp) / duration, 1);

        var easeOut = 1 - Math.pow(1 - progress, 4);

        if (timestamp - lastUpdate >= updateInterval || progress === 1) {
          var currentVal = Math.floor(easeOut * (end - start) + start);

          if (progress < 0.9) {
            currentVal += Math.floor(Math.random() * 20000);

            if (currentVal > end) {
              currentVal = end - Math.floor(Math.random() * 500);
            }
          }

          el.textContent = formatNumber(currentVal);
          lastUpdate = timestamp;
        }

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          el.textContent = formatNumber(end);
        }
      }

      window.requestAnimationFrame(step);
    }

    function initSummaryCounter(summary) {
      if (!summary || summary.dataset.counterBound === 'true') {
        return;
      }

      if (summary.dataset.enableAnimation !== 'true') {
        return;
      }

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var counterEl = summary.querySelector('[data-community-reviews-counter]');

      if (!counterEl) {
        return;
      }

      var target = calculateDynamicTarget(summary.dataset.counterBase, summary.dataset.counterBaseDate);

      summary.dataset.counterBound = 'true';

      if (reducedMotion) {
        counterEl.textContent = formatNumber(target);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) {
            return;
          }

          animateValue(counterEl, 1, target, 1200);
          observer.unobserve(summary);
        },
        {
          threshold: 0.3,
        }
      );

      observer.observe(summary);
    }

    function destroyMobileCarousel(carousel) {
      if (!carousel || !carousel._crMarquee) {
        return;
      }

      var state = carousel._crMarquee;

      if (state.rafId) {
        cancelAnimationFrame(state.rafId);
      }

      if (state.resumeTimer) {
        clearTimeout(state.resumeTimer);
      }

      if (state.visibilityObserver) {
        state.visibilityObserver.disconnect();
      }

      if (state.onVisibilityChange) {
        document.removeEventListener('visibilitychange', state.onVisibilityChange);
      }

      if (state.flkty) {
        state.flkty.destroy();
      }

      carousel._crMarquee = null;

      carousel.classList.remove('is-auto-paused', 'is-user-dragging');
    }

    function initMobileCarousel(root) {
      var carousel = root.querySelector('[data-cr-mobile-carousel]');

      if (!carousel || typeof Flickity === 'undefined') {
        return;
      }

      var mobileQuery = window.matchMedia('(max-width: 767px)');

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var slides = carousel.querySelectorAll('.carousel__slide');

      if (slides.length < 2) {
        return;
      }

      destroyMobileCarousel(carousel);

      if (!mobileQuery.matches) {
        return;
      }

      var autoScroll = carousel.dataset.autoScroll === 'true' && !reducedMotion;

      var speedPxPerSec = parseFloat(carousel.dataset.scrollSpeed);

      if (isNaN(speedPxPerSec) || speedPxPerSec <= 0) {
        speedPxPerSec = 40;
      }

      var prevBtn = carousel.querySelector('.flickity-prev');

      var nextBtn = carousel.querySelector('.flickity-next');

      var flkty = new Flickity(carousel, {
        cellAlign: 'left',
        contain: false,
        wrapAround: true,
        freeScroll: true,
        freeScrollFriction: 0.08,
        prevNextButtons: false,
        pageDots: false,
        cellSelector: '.carousel__slide',
        draggable: true,
        autoPlay: false,
        percentPosition: false,
        rightToLeft: document.dir === 'rtl',
      });

      var state = {
        flkty: flkty,
        rafId: null,
        resumeTimer: null,
        paused: false,
        inView: true,
        lastTs: null,
        visibilityObserver: null,
        onVisibilityChange: null,
      };

      carousel._crMarquee = state;

      function clearResumeTimer() {
        if (state.resumeTimer) {
          clearTimeout(state.resumeTimer);
          state.resumeTimer = null;
        }
      }

      function pauseAuto(temporary) {
        if (!autoScroll) {
          return;
        }

        state.paused = true;
        state.lastTs = null;

        carousel.classList.add('is-auto-paused');

        clearResumeTimer();

        if (temporary) {
          state.resumeTimer = setTimeout(function () {
            state.paused = false;
            state.lastTs = null;

            carousel.classList.remove('is-auto-paused');
          }, 1800);
        }
      }

      function tick(timestamp) {
        if (!carousel._crMarquee || carousel._crMarquee.flkty !== flkty) {
          return;
        }

        if (autoScroll && !state.paused && state.inView && !document.hidden && mobileQuery.matches) {
          if (state.lastTs === null) {
            state.lastTs = timestamp;
          }

          var delta = Math.min(timestamp - state.lastTs, 64);

          state.lastTs = timestamp;
          flkty.x -= (speedPxPerSec * delta) / 1000;

          flkty.positionSlider();
        } else {
          state.lastTs = null;
        }

        state.rafId = requestAnimationFrame(tick);
      }

      flkty.on('dragStart', function () {
        carousel.classList.add('is-user-dragging');

        pauseAuto(false);
      });

      flkty.on('dragEnd', function () {
        carousel.classList.remove('is-user-dragging');

        pauseAuto(true);
      });

      flkty.on('pointerUp', function () {
        if (!carousel.classList.contains('is-user-dragging')) {
          pauseAuto(true);
        }
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          pauseAuto(true);
          flkty.previous();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          pauseAuto(true);
          flkty.next();
        });
      }

      state.visibilityObserver = new IntersectionObserver(
        function (entries) {
          state.inView = Boolean(entries[0] && entries[0].isIntersecting);

          if (!state.inView) {
            state.lastTs = null;
          }
        },
        {
          threshold: 0.15,
        }
      );

      state.visibilityObserver.observe(carousel);

      state.onVisibilityChange = function () {
        if (document.hidden) {
          state.lastTs = null;
        }
      };

      document.addEventListener('visibilitychange', state.onVisibilityChange);

      if (autoScroll) {
        state.rafId = requestAnimationFrame(tick);
      }

      flkty.resize();
    }

    function resizeMobileCarousel(root) {
      var carousel = root.querySelector('[data-cr-mobile-carousel]');

      if (carousel && carousel._crMarquee && carousel._crMarquee.flkty) {
        carousel._crMarquee.flkty.resize();
      }
    }

    function isElementVisible(el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    function applyTextExpanded(wrap, expanded) {
      var toggle = wrap.querySelector('[data-cr-text-toggle]');

      if (!toggle) {
        return;
      }

      var moreLabel = toggle.querySelector('[data-more]');
      var lessLabel = toggle.querySelector('[data-less]');

      if (expanded) {
        wrap.classList.remove('is-collapsed');
        toggle.setAttribute('aria-expanded', 'true');

        if (moreLabel) {
          moreLabel.hidden = true;
        }

        if (lessLabel) {
          lessLabel.hidden = false;
        }
      } else {
        wrap.classList.add('is-collapsed');
        toggle.setAttribute('aria-expanded', 'false');

        if (moreLabel) {
          moreLabel.hidden = false;
        }

        if (lessLabel) {
          lessLabel.hidden = true;
        }
      }
    }

    function bindTextToggle(wrap, root) {
      var toggle = wrap.querySelector('[data-cr-text-toggle]');

      if (!toggle || toggle.dataset.bound === 'true') {
        return;
      }

      toggle.dataset.bound = 'true';

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var willExpand = wrap.classList.contains('is-collapsed');
        var card = wrap.closest('[data-review-id]');
        var reviewId = card ? card.getAttribute('data-review-id') : '';
        var targets;

        if (reviewId) {
          targets = root.querySelectorAll(
            '[data-review-id="' + reviewId + '"] [data-cr-text-wrap].is-collapsible'
          );
        } else {
          targets = [wrap];
        }

        targets.forEach(function (target) {
          applyTextExpanded(target, willExpand);
        });

        resizeMobileCarousel(root);
      });
    }

    function initReviewTextCollapse(root) {
      if (!root) {
        return;
      }

      root.querySelectorAll('[data-cr-text-wrap]').forEach(function (wrap) {
        if (wrap.dataset.collapseInit === 'true') {
          return;
        }

        // Hidden desktop/mobile twin has 0 height — skip until visible
        if (!isElementVisible(wrap)) {
          return;
        }

        var content = wrap.querySelector('.community-reviews__card-text');
        var toggle = wrap.querySelector('[data-cr-text-toggle]');

        if (!content || !toggle) {
          return;
        }

        var maxHeight = parseInt(wrap.dataset.maxHeight, 10) || 260;

        wrap.style.setProperty('--cr-text-max-height', maxHeight + 'px');
        wrap.classList.add('is-collapsible');
        wrap.classList.remove('is-collapsed');

        // Measure natural height of .community-reviews__card-text
        void content.offsetHeight;
        var fullHeight = content.scrollHeight;

        // Show toggle only when text is taller than the 260px baseline
        if (fullHeight <= maxHeight + 1) {
          wrap.classList.remove('is-collapsible', 'is-collapsed');
          wrap.dataset.collapseInit = 'skip';
          toggle.hidden = true;
          return;
        }

        wrap.classList.add('is-collapsed');
        wrap.dataset.collapseInit = 'true';
        toggle.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
        bindTextToggle(wrap, root);
      });
    }

    function scheduleReviewTextCollapse(root) {
      if (!root) {
        return;
      }

      var run = function (retrySkipped) {
        if (retrySkipped) {
          root.querySelectorAll('[data-cr-text-wrap]').forEach(function (wrap) {
            if (wrap.dataset.collapseInit === 'skip') {
              wrap.dataset.collapseInit = '';
            }
          });
        }

        initReviewTextCollapse(root);
      };

      // Wait a frame so card width/fonts settle before height compare
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          run(false);
        });
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready
          .then(function () {
            run(true);
          })
          .catch(function () {});
      }
    }

    function syncMobileCarousel(root) {
      var carousel = root.querySelector('[data-cr-mobile-carousel]');

      if (!carousel) {
        return;
      }

      var mobileQuery = window.matchMedia('(max-width: 767px)');

      if (mobileQuery.matches) {
        if (!carousel._crMarquee) {
          initMobileCarousel(root);
        } else if (carousel._crMarquee.flkty) {
          carousel._crMarquee.flkty.resize();
        }
      } else {
        destroyMobileCarousel(carousel);
      }

      // Re-measure newly visible desktop/mobile text nodes
      scheduleReviewTextCollapse(root);
    }

    function ensureLoopClones(root) {
      root.querySelectorAll('.community-reviews__col--scroll .community-reviews__track').forEach(function (track) {
        var groups = track.querySelectorAll(':scope > .community-reviews__track-group');
        if (groups.length === 1) {
          var clone = groups[0].cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[data-deferred-watched]').forEach(function (node) {
            node.removeAttribute('data-deferred-watched');
          });
          clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function (node) {
            node.setAttribute('tabindex', '-1');
          });
          clone.querySelectorAll('[id]').forEach(function (node) {
            var oldId = node.id;
            var newId = oldId + '-loop-copy';
            clone.querySelectorAll('[aria-controls="' + oldId + '"]').forEach(function (control) {
              control.setAttribute('aria-controls', newId);
            });
            node.id = newId;
          });
          track.appendChild(clone);
        }
        track.dataset.loopReady = 'true';
      });
    }

    function initSection(root) {
      if (!root) {
        return;
      }

      ensureLoopClones(root);

      root.querySelectorAll('.community-reviews__col--summary').forEach(initSummaryCounter);

      scheduleReviewTextCollapse(root);

      var mobileQuery = window.matchMedia('(max-width: 767px)');

      if (root._crMobileQueryHandler) {
        if (typeof mobileQuery.removeEventListener === 'function') {
          mobileQuery.removeEventListener('change', root._crMobileQueryHandler);
        } else if (typeof mobileQuery.removeListener === 'function') {
          mobileQuery.removeListener(root._crMobileQueryHandler);
        }
      }

      function onViewportChange() {
        syncMobileCarousel(root);
      }

      root._crMobileQueryHandler = onViewportChange;

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', onViewportChange);
      } else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(onViewportChange);
      }

      syncMobileCarousel(root);
    }

    function watchSection(root) {
      if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
        initSection(root);
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0] || !entries[0].isIntersecting) return;
        observer.disconnect();
        initSection(root);
      }, { rootMargin: '300px 0px' });
      observer.observe(root);
    }

    function boot() {
      document.querySelectorAll('.community-reviews').forEach(watchSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.community-reviews');

      if (!root) {
        return;
      }

      root.querySelectorAll('.community-reviews__col--summary').forEach(function (element) {
        element.dataset.counterBound = '';
      });

      root.querySelectorAll('[data-cr-text-wrap]').forEach(function (wrap) {
        wrap.dataset.collapseInit = '';
        wrap.classList.remove('is-collapsible', 'is-collapsed');

        var toggle = wrap.querySelector('[data-cr-text-toggle]');

        if (toggle) {
          toggle.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
          toggle.dataset.bound = '';
        }
      });

      watchSection(root);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('.community-reviews');

      if (!root) {
        return;
      }

      var carousel = root.querySelector('[data-cr-mobile-carousel]');

      destroyMobileCarousel(carousel);

      var mobileQuery = window.matchMedia('(max-width: 767px)');

      if (root._crMobileQueryHandler) {
        if (typeof mobileQuery.removeEventListener === 'function') {
          mobileQuery.removeEventListener('change', root._crMobileQueryHandler);
        } else if (typeof mobileQuery.removeListener === 'function') {
          mobileQuery.removeListener(root._crMobileQueryHandler);
        }

        root._crMobileQueryHandler = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('customer-story-atc')) {
    class CustomerStoryAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.variantId = this.dataset.variantId;
        this.giftVariantId = this.dataset.giftVariantId;
        this.giftAvailable = this.dataset.giftAvailable !== 'false';
        if (!this.button || !this.variantId) return;
        this.onClick = this.onClick.bind(this);
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onClick);
      }

      getSectionsToRender() {
        return [
          { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
          { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
          { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
        ];
      }

      onClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.button.disabled || this.button.classList.contains('loading')) return;

        this.button.classList.add('loading');
        this.button.setAttribute('aria-disabled', 'true');

        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', 1);
        formData.append(
          'sections',
          this.getSectionsToRender().map((section) => section.section)
        );
        formData.append('sections_url', window.location.pathname);

        const cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';

        GiftWithPurchase.add({
          addPrimary: () => fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/javascript',
            },
            body: formData,
          }),
          primaryVariantId: this.variantId,
          quantity: 1,
          giftVariantId: this.giftVariantId,
          giftAvailable: this.giftAvailable,
          sections: this.getSectionsToRender().map((section) => section.section),
          sectionsUrl: window.location.pathname,
        })
          .then((result) => {
            const response = result.response;
            if (response.status) return;
            this.renderContents(response);
            if (typeof dispatchCustomEvent === 'function') {
              dispatchCustomEvent('cart:item-added', {
                product: result.primaryItem,
              });
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.button.classList.remove('loading');
            this.button.removeAttribute('aria-disabled');
          });
      }

      getSectionInnerHTML(html, selector) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const node = doc.querySelector(selector);
        return node ? node.innerHTML : '';
      }

      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          const root = document.getElementById(section.id);
          if (!root || !parsedState.sections || !parsedState.sections[section.section]) return;
          const target = root.querySelector(section.selector) || root;
          target.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });

        const drawer = document.getElementById('Cart-Drawer');
        if (drawer) {
          document.body.classList.add('open-cc');
          drawer.classList.add('active');
          if (typeof dispatchCustomEvent === 'function') {
            dispatchCustomEvent('cart-drawer:open');
          }
        }
      }
    }

    customElements.define('customer-story-atc', CustomerStoryAtc);
  }

  (function () {
    var DRAG_THRESHOLD = 10;
    var RESUME_DELAY = 1600;

    function getTranslateX(el) {
      var style = window.getComputedStyle(el);
      var transform = style.transform;
      if (!transform || transform === 'none') return 0;
      if (typeof DOMMatrixReadOnly !== 'undefined') {
        return new DOMMatrixReadOnly(transform).m41;
      }
      var match = transform.match(/matrix\(([^)]+)\)/);
      if (!match) return 0;
      var parts = match[1].split(',');
      return parseFloat(parts[4]) || 0;
    }

    function getLoopWidth(track) {
      var group = track.querySelector('.customer-stories__group');
      if (group && group.offsetWidth > 0) return group.offsetWidth;
      return track.scrollWidth > 0 ? track.scrollWidth / 2 : 0;
    }

    // Keep drag offset inside one seamless cycle (-loopWidth, 0]
    function wrapTranslate(x, loopWidth) {
      if (!loopWidth || loopWidth <= 0) return x;
      var wrapped = x % loopWidth;
      if (wrapped > 0) wrapped -= loopWidth;
      if (wrapped <= -loopWidth) wrapped += loopWidth;
      return wrapped;
    }

    function initMarquee(root) {
      var marquee = root.querySelector('.customer-stories__marquee');
      var track = root.querySelector('.customer-stories__track');
      if (!marquee || !track || marquee.dataset.csDragInit === 'true') return;
      marquee.dataset.csDragInit = 'true';

      if (marquee.dataset.autoScroll === 'false') {
        track.dataset.loopReady = 'true';
        return;
      }

      var group = track.querySelector('.customer-stories__group');
      if (group && track.querySelectorAll('.customer-stories__group').length === 1) {
        var clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[data-deferred-watched]').forEach(function (node) {
          node.removeAttribute('data-deferred-watched');
        });
        clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function (node) {
          node.setAttribute('tabindex', '-1');
        });
        clone.querySelectorAll('[id]').forEach(function (node) {
          var oldId = node.id;
          var newId = oldId + '-loop-copy';
          clone.querySelectorAll('[aria-controls="' + oldId + '"]').forEach(function (control) {
            control.setAttribute('aria-controls', newId);
          });
          node.id = newId;
        });
        track.appendChild(clone);
      }
      track.dataset.loopReady = 'true';

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) return;

      var pointerId = null;
      var startX = 0;
      var startTranslate = 0;
      var loopWidth = 0;
      var dragActive = false;
      var didDrag = false;
      var resumeTimer = null;

      function clearResumeTimer() {
        if (resumeTimer) {
          clearTimeout(resumeTimer);
          resumeTimer = null;
        }
      }

      function scheduleResume() {
        clearResumeTimer();
        resumeTimer = setTimeout(function () {
          track.style.animation = '';
          track.style.transform = '';
          marquee.classList.remove('is-paused', 'is-dragging');
          resumeTimer = null;
        }, RESUME_DELAY);
      }

      function beginDrag(event) {
        if (dragActive) return;
        dragActive = true;
        didDrag = true;
        clearResumeTimer();
        marquee.classList.add('is-paused', 'is-dragging');

        loopWidth = getLoopWidth(track);
        startTranslate = wrapTranslate(getTranslateX(track), loopWidth);
        track.style.animation = 'none';
        track.style.transform = 'translateX(' + startTranslate + 'px)';
      }

      function capturePointer(event) {
        if (!marquee.setPointerCapture) return;
        try {
          marquee.setPointerCapture(event.pointerId);
        } catch (err) {}
      }

      function releasePointer(event) {
        if (!marquee.releasePointerCapture) return;
        try {
          if (marquee.hasPointerCapture && marquee.hasPointerCapture(event.pointerId)) {
            marquee.releasePointerCapture(event.pointerId);
          } else if (!marquee.hasPointerCapture) {
            marquee.releasePointerCapture(event.pointerId);
          }
        } catch (err) {}
      }

      function onPointerDown(event) {
        if (event.button != null && event.button !== 0) return;
        if (event.target.closest('customer-story-atc, button, input, textarea, select')) return;

        // Stop native image/link drag from stealing the gesture before capture
        event.preventDefault();

        pointerId = event.pointerId;
        startX = event.clientX;
        dragActive = false;
        didDrag = false;
        capturePointer(event);
      }

      function onPointerMove(event) {
        if (pointerId == null || event.pointerId !== pointerId) return;
        var delta = event.clientX - startX;

        if (!dragActive) {
          if (Math.abs(delta) <= DRAG_THRESHOLD) return;
          beginDrag(event);
          // Re-base so first move after threshold does not jump
          startX = event.clientX;
          delta = 0;
        }

        var next = wrapTranslate(startTranslate + delta, loopWidth);
        track.style.transform = 'translateX(' + next + 'px)';
        event.preventDefault();
      }

      function onPointerUp(event) {
        if (pointerId == null || event.pointerId !== pointerId) return;
        pointerId = null;
        releasePointer(event);

        if (!dragActive) {
          marquee.classList.remove('is-dragging', 'is-paused');
          return;
        }

        marquee.classList.remove('is-dragging');

        var current = wrapTranslate(getTranslateX(track), loopWidth);
        track.style.transform = 'translateX(' + current + 'px)';

        scheduleResume();
        dragActive = false;
      }

      function onClickCapture(event) {
        if (!didDrag) return;
        if (event.target.closest('a')) {
          event.preventDefault();
          event.stopPropagation();
        }
        didDrag = false;
      }

      marquee.addEventListener('pointerdown', onPointerDown);
      marquee.addEventListener('pointermove', onPointerMove);
      marquee.addEventListener('pointerup', onPointerUp);
      marquee.addEventListener('pointercancel', onPointerUp);
      marquee.addEventListener('click', onClickCapture, true);
      // Extra guard: some browsers still fire HTML5 dragstart on images/links
      marquee.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });
    }

    function watchMarquee(root) {
      if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
        initMarquee(root);
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0] || !entries[0].isIntersecting) return;
        observer.disconnect();
        initMarquee(root);
      }, { rootMargin: '300px 0px' });
      observer.observe(root);
    }

    function boot() {
      document.querySelectorAll('.customer-stories').forEach(watchMarquee);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.customer-stories');
      if (root) watchMarquee(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showcase-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updatePageProgress = (flkty, bar) => {
      if (!flkty || !bar) return;
      const totalPages = flkty.slides.length || 1;
      const currentPage = flkty.selectedIndex + 1;
      bar.style.width = `${(currentPage / totalPages) * 100}%`;
    };

    const bindShowcaseControls = (root) => {
      const wrap = root.querySelector('.collection-showcase__carousel-wrap');
      if (!wrap || wrap.dataset.controlsBound === 'true') return;

      const slideshow = wrap.querySelector('.collection-showcase__carousel');
      const prev = wrap.querySelector('.collection-showcase__nav--prev');
      const next = wrap.querySelector('.collection-showcase__nav--next');
      const progressBar = wrap.querySelector('.collection-showcase__progress-bar');
      if (!slideshow || !prev || !next) return;

      const attach = () => {
        const flkty = typeof Flickity !== 'undefined' ? Flickity.data(slideshow) : null;
        if (!flkty) {
          requestAnimationFrame(attach);
          return;
        }

        wrap.dataset.controlsBound = 'true';
        prev.addEventListener('click', () => flkty.previous());
        next.addEventListener('click', () => flkty.next());

        if (progressBar) {
          updatePageProgress(flkty, progressBar);
          flkty.on('change', () => updatePageProgress(flkty, progressBar));
        }
      };

      attach();
    };

    const init = (event) => {
      const scope = event && event.target ? event.target : document;
      scope.querySelectorAll('.section-showcase-features').forEach(bindShowcaseControls);
    };

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-header"]) return;
  try {
    
  (() => {
    const SELECTOR = '.template-header--description-container';

    const initDescriptionCollapse = (container) => {
      if (container.dataset.collapseInit === 'true') return;

      const content = container.querySelector('.template-header--description');
      const toggle = container.querySelector('.template-header--description-toggle');
      if (!content || !toggle) return;

      const lines = parseInt(container.dataset.descriptionLines, 10) || 3;
      const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
      const collapsedHeight = Math.ceil(lineHeight * lines);

      // 内容未超出折叠高度时不显示按钮
      if (content.scrollHeight <= collapsedHeight + 2) return;

      container.dataset.collapseInit = 'true';
      container.classList.add('is-collapsible', 'is-collapsed');
      toggle.hidden = false;
      content.style.maxHeight = `${collapsedHeight}px`;

      const moreLabel = toggle.querySelector('[data-more]');
      const lessLabel = toggle.querySelector('[data-less]');

      toggle.addEventListener('click', () => {
        const isCollapsed = container.classList.contains('is-collapsed');

        if (isCollapsed) {
          container.classList.remove('is-collapsed');
          content.style.maxHeight = `${content.scrollHeight}px`;
          toggle.setAttribute('aria-expanded', 'true');
          if (moreLabel) moreLabel.hidden = true;
          if (lessLabel) lessLabel.hidden = false;
        } else {
          container.classList.add('is-collapsed');
          content.style.maxHeight = `${collapsedHeight}px`;
          toggle.setAttribute('aria-expanded', 'false');
          if (moreLabel) moreLabel.hidden = false;
          if (lessLabel) lessLabel.hidden = true;
        }
      });
    };

    const initAll = (root = document) => {
      root.querySelectorAll(SELECTOR).forEach(initDescriptionCollapse);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
